var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    {
      staticClass: "ml-auto mb-auto",
      attrs: {
        size: "sm",
        "toggle-class": "btn-default-borderless",
        "no-caret": "",
        variant: "none"
      }
    },
    [
      _c("ItpIcon", {
        staticClass: "mx-1",
        attrs: { slot: "button-content", fa: "ellipsis-v" },
        slot: "button-content"
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }